const INCIDENT_TYPES_QUERY_KEY = 'incident-types';
const INCIDENT_QUERY_KEY = 'incident';

export { INCIDENT_TYPES_QUERY_KEY, INCIDENT_QUERY_KEY };
